import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';

export function useHelpStore() {
    const module = useVuexStore<HelpStore>('ui/help');
    const showHelp = (options?: { shouldHideOnClose?: boolean}) => module.action('showHelp')({ shouldHideOnClose: options?.shouldHideOnClose });
    return {
        showHelp,
    };
}

type HelpStore = {
    actions: {
        showHelp(_ctx: unknown, options: { shouldHideOnClose?: boolean}): void;
    }
};
